import { call, put, select, takeLatest } from "redux-saga/effects";
import { fetchFinancials } from "../../../services/accIqService";
import { FETCH_SELF_FINANCIALS_REQUEST, fetchSelfFinancialsFailure, fetchSelfFinancialsSuccess } from "../actions/selfFinancialsActions";


// Worker Saga
function* fetchSelfFinancialsSaga() {
  try {
    const payload = yield select(state=>state?.selfFinancialsReducer?.payload);

    const data = yield call(fetchFinancials,payload);
    yield put(fetchSelfFinancialsSuccess(data));
  } catch (error) {
    yield put(fetchSelfFinancialsFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchSelfFinancials() {
  yield takeLatest(FETCH_SELF_FINANCIALS_REQUEST, fetchSelfFinancialsSaga);
}
